// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:23:36.693Z
// Property: Netherley Park (ID: 6767906449167332)
// Collections: 17 amenities, 8 floorplans (live), 26 photos, 32 POIs, 3 reviews, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167332",
  "property_external_id": "100160118",
  "property_zillow_url": "https://www.zillow.com/apartments/union-city-ga/netherley-park/5XhtzQ/",
  "property_apartments_url": "https://www.apartments.com/netherley-park-union-city-ga/7vykmbx/",
  "property_google_business_url": "https://www.google.com/maps/place/Netherley+Park+Apartments/data=!4m2!3m1!1s0x0:0xd21f1c321776dfb9?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "netherley-park",
  "property_name": "Netherley Park",
  "property_website_url": "https://www.liveatnetherleypark.com/",
  "property_domain": "https://www.liveatnetherleypark.com/",
  "property_address": "6770 Buffington Rd",
  "property_full_address": "6770 Buffington Rd, Union City, GA 30291",
  "property_address_1": "6770 Buffington Rd",
  "property_address_2": null,
  "property_address_city": "Union City",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30291",
  "property_address_country": "US",
  "property_address_county": "Fulton County",
  "property_neighborhood_address": "South Fulton",
  "property_address_latitude": "33.5682035",
  "property_address_longitude": "-84.5121309",
  "property_email": null,
  "property_phone": "(470) 852-6408",
  "property_call_tracking_phone": "844-601-0181",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to Netherley Park in Union City, GA, where modern living meets unparalleled comfort. Choose from spacious one, two, or three-bedroom floor plans featuring equipped kitchens and large closets. Enjoy a refreshing swim, relax by the lake, or stay active at our fitness center. Your perfect home awaits!",
  "property_long_description": "Welcome to Netherley Park, your ideal apartment community in Union City, GA! Offering a variety of spacious floor plans, our one, two, and three-bedroom apartments are designed to cater to your lifestyle needs. With modern comforts and stylish finishes including faux wood flooring, all-black appliances, and ample closet space, your new home is both functional and attractive.\n\nAt Netherley Park, we prioritize your comfort and convenience. Dive into relaxation at our sparkling swimming pool, or create cherished memories at our playground and picnic area by the lake—perfect for fun gatherings with friends and family. For pet lovers, our pet-friendly community allows you to welcome your furry friends with open arms!\n\nStay active with our state-of-the-art fitness center, and enjoy the ease of maintenance-free living thanks to our on-site professional management and laundry facility. Effortless parking and a convenient location make your daily routine seamless, whether you're commuting to work or exploring the vibrant nearby surroundings.\n\nYour dream apartment awaits you at Netherley Park. Don’t miss out on the opportunity to experience this charming community where modern living meets comfort. Find your new home today by browsing our availability or scheduling a tour to visit our beautiful grounds! Come and see why Netherley Park is the perfect place to call home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-65ad-70f9-9694-55b9f985105e.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
    "public_id": "019d54ec-65ad-70f9-9694-55b9f985105e",
    "storage_key": "property/6767906449167332/019d54ec-65ad-70f9-9694-55b9f985105e.webp",
    "width": 1900,
    "height": 935
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "281",
  "property_year_built": "1988",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "75.08896797153025",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$500.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": "We welcome cats and dogs up to 25 lbs. Maximum 2 pets per unit.",
  "property_pet_policy_description": "We welcome cats and dogs up to 25 lbs. Pet fee: $250. Monthly pet rent: $35. Maximum 2 pets per unit.",
  "property_petpolicy_info": "Pet Policy\n\nPet Types: Cats & Dogs\nBreed Restrictions Apply\nMax Weight: 25\nMaximum Pets Per Unit: 2",
  "property_online_leasing_url": "https://netherleyparkaxia.prospectportal.com/Union City/Netherley Park",
  "property_resident_portal_url": "https://netherleyparkaxia.residentportal.com/auth",
  "property_apply_now_url": "https://netherleyparkaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160118/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-5cc4-736b-8f36-fa33a454ed9a.webp",
  "property_primary_logo_media": {
    "alt_text": "Netherley Park logo.",
    "public_id": "019d54ec-5cc4-736b-8f36-fa33a454ed9a",
    "storage_key": "property/6767906449167332/019d54ec-5cc4-736b-8f36-fa33a454ed9a.webp",
    "width": 250,
    "height": 82
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7459-bce4-7641-bd22-03c2d29848e4.webp",
  "property_secondary_logo_media": {
    "alt_text": "Netherley Park logo with dark blue N and P letters and name below.",
    "public_id": "019d7459-bce4-7641-bd22-03c2d29848e4",
    "storage_key": "property/6767906449167332/019d7459-bce4-7641-bd22-03c2d29848e4.webp",
    "width": 1200,
    "height": 900
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019ddf80-733e-7509-b406-47448bdd75ac.webp",
  "property_fav_icon_media": {
    "alt_text": "N-P logo",
    "public_id": "019ddf80-733e-7509-b406-47448bdd75ac",
    "storage_key": "property/6767906449167332/019ddf80-733e-7509-b406-47448bdd75ac.webp",
    "width": 76,
    "height": 50
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-94ee-772b-9c0c-57493b35396a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d54ec-94ee-772b-9c0c-57493b35396a",
    "storage_key": "property/6767906449167332/019d54ec-94ee-772b-9c0c-57493b35396a.webp",
    "width": 250,
    "height": 82
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-87ca-75f3-8532-a59e8dc95267.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d54ec-87ca-75f3-8532-a59e8dc95267",
    "storage_key": "property/6767906449167332/019d54ec-87ca-75f3-8532-a59e8dc95267.webp",
    "width": 250,
    "height": 82
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "616 - 1285",
  "property_sqft_min": "616",
  "property_sqft_max": "1285",
  "property_price_range": "$1117 - $1699",
  "property_price_min": "1106",
  "property_price_max": "1699",
  "property_available_units": 70,
  "property_facebook_url": "https://www.facebook.com/NetherleyParkApts",
  "property_instagram_url": "https://www.instagram.com/netherleypark/",
  "property_twitter_url": "https://x.com/netherleypark",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJB070Rhrk9IgRud92FzIcH9I",
  "property_youtube_url": "https://www.youtube.com/channel/UCI3n9S6joYY-BDta-6_oJkw",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Union+City%2C+GA",
  "property_tiktok_url": "https://www.tiktok.com/@netherley.park.ap/video/7378107304081837358",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Netherley Park",
  "property_home_romance_title": "Embrace a New Lifestyle, Love Where You Live Today",
  "property_home_amenities_blurb": "Nestled in the heart of Union City, GA, Netherly Park offers spacious floor plans designed for comfort and convenience. Enjoy a resort-style swimming pool, picnic area by the lake, and a pet-friendly vibe. With on-site management and maintenance-free living, experience effortless elegance at your new home. Join us today!",
  "property_home_floorplans_blurb": "Welcome to Netherley Park in Union City, GA, where comfort meets style. Choose from our thoughtfully designed one, two, or three-bedroom apartments that reflect your lifestyle. Each spacious floor plan offers a unique blend of modern living and convenience. Browse our available homes today and find your ideal sanctuary!",
  "property_home_gallery_blurb": "Welcome to Netherly Park in Union City, GA, where comfort meets convenience. Indulge in spacious floor plans featuring faux wood flooring and all-black appliances. Dive into relaxation at our swimming pool or enjoy a picnic by the lake. Picture yourself living here, where a pet-friendly lifestyle and professional management await!",
  "property_home_neighborhood_blurb": "At Netherley Park in Union City, GA, embrace a vibrant lifestyle surrounded by parks like Kenwood and Duncan, plus essential amenities including Publix and The Home Depot. With spacious one-, two-, and three-bedroom layouts, your ideal home awaits. Dive into the community and uncover all the local treasures nearby!",
  "property_home_reviews_blurb": "At Netherley Park in Union City, GA, residents thrive in a vibrant community where comfort meets convenience. One happy renter shares, “The atmosphere here feels like home.” Dive into our reviews and see what our residents have to say about living at Netherley Park—your perfect retreat awaits!",
  "property_neighborhood_blurb": "At Netherley Park in Union City, GA, your vibrant lifestyle awaits! Nestled near lush parks like Kenwood and Duncan, our community offers easy access to family-friendly attractions, top-notch fitness centers, and essential shopping at Publix and ALDI. Immerse yourself in the energetic spirit of the neighborhood—your adventure starts now!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Netherley Park in Union City, GA, enjoy a lifestyle of comfort and convenience. Choose from spacious one, two, or three-bedroom floor plans featuring modern kitchens and inviting living spaces. Dive into our refreshing swimming pool, unwind at the picnic area by the lake, or benefit from our pet-friendly policies. Your new home awaits!",
  "property_applynow_blurb": "At Netherley Park in Union City, GA, your ideal home awaits. Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities like a sparkling swimming pool, pet-friendly spaces, and a serene picnic area by the lake. Embrace a maintenance-free lifestyle and lease online today!",
  "property_contactus_blurb": "At Netherley Park in Union City, GA, find your perfect home with our thoughtfully designed one, two, and three-bedroom floor plans. Each space offers comfort and style, tailored to your lifestyle. Have questions? Our friendly leasing team is here to help you every step of the way—reach out today!",
  "property_faqs_blurb": "Nestled in the heart of Union City, GA, Netherley Park offers a variety of thoughtfully designed floor plans—one, two, and three bedrooms to fit your lifestyle. Curious about amenities and community life? Browse our FAQs page for answers to your most pressing questions and discover what makes Netherley Park a great place to call home!",
  "property_floorplans_blurb": "At Netherley Park in Union City, GA, choose from a diverse selection of thoughtfully designed one, two, and three-bedroom apartment homes. Each layout maximizes space and comfort, ensuring an inviting retreat. Browse our available floor plans and envision your new life in a community where style meets convenience.",
  "property_gallery_blurb": "At Netherley Park in Union City, GA, our vibrant community offers spacious one, two, and three-bedroom floor plans designed for comfort. Enjoy amenities like a refreshing swimming pool, a pet-friendly playground, and a lakeside picnic area, all while experiencing maintenance-free living. Picture yourself thriving in this inviting atmosphere!",
  "property_interactivemap_blurb": "Nestled in vibrant Union City, GA, Netherley Park offers spacious one, two, and three-bedroom apartments designed for comfort and convenience. Enjoy a maintenance-free lifestyle with fantastic amenities like a swimming pool, pet-friendly playground, and a serene picnic area by the lake. Start your journey with our interactive community map!",
  "property_pets_blurb": "At Netherley Park, your furry companions are a beloved part of our pet-friendly apartment community. We happily welcome up to two pets per residence, ensuring they feel just as at home as you do. With an expansive playground and plenty of green space nearby, your pets will have room to explore and enjoy. Feel free to contact us for full details regarding pet fees, monthly rent, and any additional questions you may have.",
  "property_referafriend_blurb": "At Netherley Park in Union City, GA, our vibrant community welcomes your friends with open arms! With spacious one, two, and three-bedroom floor plans, everyone can find their perfect home. Great friends make great neighbors—refer a friend today and elevate your living experience together!",
  "property_residentaccess_blurb": "Welcome to Netherley Park in Union City, GA, where your ideal living space awaits! We offer thoughtfully designed one, two, and three-bedroom floor plans tailored for comfort. Quickly manage your residency; access your resident portal to pay rent, schedule maintenance, and enjoy seamless living at your new home!",
  "property_reviews_blurb": "At Netherley Park in Union City, GA, our residents love the welcoming atmosphere and vibrant community spirit. One resident says, “Netherley Park feels like home!\" Check out our reviews to see why so many choose to call us their sanctuary. Join the conversation about your future living experience!",
  "property_created_at": "1775246171217",
  "property_scheduletour_blurb": "Welcome to Netherley Park in Union City, GA, where your ideal home awaits. With thoughtfully designed one, two, and three-bedroom floor plans, you’ll find the perfect fit for your lifestyle. Curious about life here? Dive into our residents’ experiences and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out! At Netherley Park in Union City, GA, we offer stylish one, two, and three-bedroom floor plans designed for comfort and convenience. Your journey to exceptional living begins here—stay tuned as a team member will connect with you soon to assist with your apartment search!",
  "property_virtualtours_blurb": "Welcome to Netherley Park in Union City, GA, where modern living meets comfort. Choose from stylish one, two, or three-bedroom floor plans designed to fit your lifestyle. Embark on a virtual tour today and envision your future home within our vibrant community!",
  "property_copyright": "2026 All Rights Reserved. Netherley Park",
  "property_seo_title_home": "Netherley Park |  Apartments in Union City, GA",
  "property_seo_description_home": "Experience comfort at Netherley Park in Union City, GA. Choose from spacious 1, 2, or 3-bedroom homes with a pool, fitness center, and lake-side picnic area.",
  "property_seo_title_floorplans": "Floor Plans | Union City, GA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal home at Netherley Park, Union City’s top apartment community, offering cozy one-bedroom to spacious three-bedroom layouts!",
  "property_seo_title_amenities": "Amenities | Union City, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Netherley Park, Union City, GA. Enjoy spacious floor plans, a pool, and a pet-friendly, maintenance-free lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Union City, GA",
  "property_seo_description_gallery": "Discover effortless living at Netherley Park, Union City, GA. Spacious floor plans, serene lake picnics, and pet-friendly amenities await!",
  "property_seo_title_virtualtours": "Virtual Tours | Netherley Park Apartments",
  "property_seo_description_virtualtours": "Experience Netherley Park in Union City, GA! Take a virtual tour of our spacious one, two, and three-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Netherley Park Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Netherley Park in Union City, GA! Spacious one to three-bedroom layouts, luxurious amenities, and a vibrant community await you!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Union City, GA",
  "property_seo_description_neighborhood": "Experience the vibrant life at Netherley Park in Union City, GA! Uncover local hotspots and treat yourself to nearby gems in our welcoming neighborhood.",
  "property_seo_title_contact": "Contact Us | Netherley Park",
  "property_seo_description_contact": "Reach out to Netherley Park in Union City, GA! Explore our diverse floor plans—1, 2, and 3 bedrooms—designed for your lifestyle. We’re here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Union City, GA",
  "property_seo_description_faqs": "Discover Netherly Park in Union City, GA! Explore spacious floor plans and amenities like a pool and fitness center. We've got you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Union City, GA",
  "property_seo_description_reviews": "Join Netherly Park in Union City, GA! Discover why our pet-friendly community with spacious floor plans is the perfect home sweet home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Union City, GA",
  "property_seo_description_applynow": "Discover Netherly Park in Union City, GA! Enjoy spacious floor plans, excellent amenities, and a maintenance-free lifestyle. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Netherly Park",
  "property_seo_description_residentaccess": "Log in to your Netherly Park portal for easy rent payments, maintenance requests, and community updates—all from your Union City home!",
  "property_seo_title_referafriend": "Refer A Friend | Netherly Park",
  "property_seo_description_referafriend": "Great friends make the best neighbors at Netherly Park in Union City, GA. Refer a friend today and build a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Netherly Park",
  "property_seo_description_scheduletour": "Discover the charm of Netherly Park in Union City, GA! Schedule a tour today to find your ideal home in our vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Netherly Park",
  "property_seo_description_privacy": "At Netherly Park in Union City, GA, your privacy matters. Uncover how we safeguard your information and enjoy peace of mind in our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Netherly Park",
  "property_seo_description_accessibility": "Experience seamless living at Netherly Park in Union City, GA. Our commitment to digital inclusion ensures everyone can access our vibrant community online.",
  "property_seo_title_sitemap": "Sitemap | Netherly Park",
  "property_seo_description_sitemap": "Navigate your way through Netherly Park's vibrant community in Union City, GA. Our sitemap makes finding your perfect apartment a breeze!",
  "property_seo_title_thankyou": "Thank You | Netherly Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Netherly Park in Union City, GA! Expect a prompt response from our team. Your next home adventure is just around the corner!",
  "property_seo_title_pets": "Pet Policy | Apartments in Union City, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793452938",
  "amenities": [
    {
      "id": "custom_4f8ba1ee-b3b4-473c-821d-19db3e9cf02f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd9c0099-32cf-438b-b48f-35bf13234a76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_058fc830-21ce-4284-810b-4762d1f58715",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db60f714-a884-4349-bdaf-472b53225b3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3c984324-3e3d-4f57-b118-d0721e622d58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "One‑Site Professional Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6694898-89d6-47e7-9832-14a6a0470a4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2542e930-762d-4a32-9ef0-4d94c9ca6ffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area by the Lake",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23b6c2a4-20c1-48b5-a98a-7e8133a3df9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Effortless Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_93b04525-6bb9-426f-ac99-ff4128332d8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f6ed3bf-b1fe-4942-af88-f2a732a3d755",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Maintenance‑Free Lifestyle",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_419695a4-8574-46f5-bfd1-15fddab1b32f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a86602e-5467-480a-901b-0f5da1cee1f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e80763a2-7f5c-4f12-b387-61562ee47ac1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e6e6dabc-b351-4d79-9527-e86fbd113549",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "All-Black Appliances in Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_65b76f82-59e6-46d9-bf4a-cc1904eb9a96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Faux Wood Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e02ff993-3527-4091-8082-5a574d187563",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13efdf18-e454-4317-8d8e-aec90de4ad8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_733f7b21-28af-402b-8c5f-75c1159c2ec9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019e02b4-d190-70fa-a983-6cc396d0ecef.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a granite countertop, sink, and large mirror. A bathtub and toilet are visible through an open doorway at Netherley Park in Union City, GA.",
        "public_id": "019e02b4-d190-70fa-a983-6cc396d0ecef",
        "storage_key": "property/6767906449167332/019e02b4-d190-70fa-a983-6cc396d0ecef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern bathroom featuring a granite-topped vanity with a clean white sink, a spacious mirror, and dark wood cabinetry. The adjoining shower/tub area is visible.",
      "link": "",
      "alt_text": "Bathroom vanity with a granite countertop, sink, and large mirror. A bathtub and toilet are visible through an open doorway at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3433f231-144a-40ce-b877-61b6706a30dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-ec67-732e-a92c-74da9b47d4f2.webp",
      "image_media": {
        "alt_text": "Lobby with seating area, reception desk, and kitchen counter at Netherley Park in Union City, GA.",
        "public_id": "019d7466-ec67-732e-a92c-74da9b47d4f2",
        "storage_key": "property/6767906449167332/019d7466-ec67-732e-a92c-74da9b47d4f2.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stylish lobby and seating area with reception desk, kitchen counter, and modern decor.",
      "link": "",
      "alt_text": "Lobby with seating area, reception desk, and kitchen counter at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d40e5ee-8e55-4d30-b639-36edc5d73e59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-edc6-700f-a6c8-d57a21c0cba9.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cherry cabinets, granite countertops, stainless steel sink and appliances at Netherley Park in Union City, GA.",
        "public_id": "019d7466-edc6-700f-a6c8-d57a21c0cba9",
        "storage_key": "property/6767906449167332/019d7466-edc6-700f-a6c8-d57a21c0cba9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A spacious kitchen featuring dark cherry wood cabinets, granite countertops, a double sink, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with dark cherry cabinets, granite countertops, stainless steel sink and appliances at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b6270ef9-874a-4aea-989a-109532e68e0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-e4df-77a0-98e0-a4c29d80680c.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by trees and a lake at Netherley Park in Union City, GA.",
        "public_id": "019d7466-e4df-77a0-98e0-a4c29d80680c",
        "storage_key": "property/6767906449167332/019d7466-e4df-77a0-98e0-a4c29d80680c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, complete with comfortable lounge chairs and scenic views of the adjacent lake.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by trees and a lake at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a144bc68-e62c-4472-b7f7-2a166b33b8d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-d1c8-700e-a772-282bf5745cd3.webp",
      "image_media": {
        "alt_text": "Large outdoor swimming pool with lounge chairs and umbrellas at Netherley Park in Union City, GA.",
        "public_id": "019d7466-d1c8-700e-a772-282bf5745cd3",
        "storage_key": "property/6767906449167332/019d7466-d1c8-700e-a772-282bf5745cd3.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Large outdoor swimming pool with lounge chairs and umbrellas at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e9bbe370-7aa3-4834-9811-236a10d4e15f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019e02b6-eedf-753c-b1d1-1dc22721a51d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with blue and grey siding, stairs, and surrounding greenery at Netherley Park in Union City, GA.",
        "public_id": "019e02b6-eedf-753c-b1d1-1dc22721a51d",
        "storage_key": "property/6767906449167332/019e02b6-eedf-753c-b1d1-1dc22721a51d.webp",
        "width": 3072,
        "height": 2145
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring blue and grey siding, well-maintained landscaping, and convenient exterior stair access.",
      "link": "",
      "alt_text": "Exterior view of apartment building with blue and grey siding, stairs, and surrounding greenery at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4c5369f-1e97-4745-a293-27be96f5574c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019e02b6-e0cc-74df-b54c-6fbe1cf70660.webp",
      "image_media": {
        "alt_text": "View of a living room with a ceiling fan and large windows, leading to an entryway with a white door at Netherley Park in Union City, GA.",
        "public_id": "019e02b6-e0cc-74df-b54c-6fbe1cf70660",
        "storage_key": "property/6767906449167332/019e02b6-e0cc-74df-b54c-6fbe1cf70660.webp",
        "width": 3072,
        "height": 2006
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a ceiling fan and abundant natural light from large windows. Includes a welcoming entryway with a front door.",
      "link": "",
      "alt_text": "View of a living room with a ceiling fan and large windows, leading to an entryway with a white door at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba5e5034-eecf-449f-9730-2254d7ebad5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019e02b6-dcca-757d-9a82-dc24c56b1f64.webp",
      "image_media": {
        "alt_text": "Apartment buildings next to a lake at Netherley Park in Union City, GA.",
        "public_id": "019e02b6-dcca-757d-9a82-dc24c56b1f64",
        "storage_key": "property/6767906449167332/019e02b6-dcca-757d-9a82-dc24c56b1f64.webp",
        "width": 3072,
        "height": 1648
      },
      "title": "Community",
      "description": "Apartment buildings overlooking a serene lake, surrounded by lush greenery and mature trees under a bright, cloudy sky.",
      "link": "",
      "alt_text": "Apartment buildings next to a lake at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25d2cc7f-6f96-497f-99fd-dd42cdb91970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019e02b6-dff7-752a-b7c1-c846e0921196.webp",
      "image_media": {
        "alt_text": "Kitchenette with breakfast bar, refrigerator, and stovetop at Netherley Park in Union City, GA.",
        "public_id": "019e02b6-dff7-752a-b7c1-c846e0921196",
        "storage_key": "property/6767906449167332/019e02b6-dff7-752a-b7c1-c846e0921196.webp",
        "width": 3072,
        "height": 2121
      },
      "title": "Apartment",
      "description": "This apartment features a compact kitchenette with a breakfast bar, perfect for a quick meal or entertaining guests. The space includes a refrigerator and stovetop.",
      "link": "",
      "alt_text": "Kitchenette with breakfast bar, refrigerator, and stovetop at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d31b45d1-15f3-46e9-a937-e154036b619a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019e02b4-d15f-7579-86d2-9b90750b2168.webp",
      "image_media": {
        "alt_text": "Kitchen with cherry cabinets, granite countertops, stainless steel sink, and black appliances at Netherley Park in Union City, GA.",
        "public_id": "019e02b4-d15f-7579-86d2-9b90750b2168",
        "storage_key": "property/6767906449167332/019e02b4-d15f-7579-86d2-9b90750b2168.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover a stylish and functional kitchen featuring rich cherry wood cabinetry, elegant granite countertops, a deep stainless steel sink, and modern black appliances.",
      "link": "",
      "alt_text": "Kitchen with cherry cabinets, granite countertops, stainless steel sink, and black appliances at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58a41e6c-8851-483c-8296-b4b34030ccdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-f5b2-76ed-9e13-db0fc70a4234.webp",
      "image_media": {
        "alt_text": "Interior view of an empty bedroom with a closet and hallway at Netherley Park in Union City, GA.",
        "public_id": "019d7466-f5b2-76ed-9e13-db0fc70a4234",
        "storage_key": "property/6767906449167332/019d7466-f5b2-76ed-9e13-db0fc70a4234.webp",
        "width": 1280,
        "height": 886
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this spacious apartment bedroom. Features a large closet and easy access to the hallway.",
      "link": "",
      "alt_text": "Interior view of an empty bedroom with a closet and hallway at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2572aa59-8b59-4325-9d87-61f864d821a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-f25f-70bd-a69d-8220027976c5.webp",
      "image_media": {
        "alt_text": "Interior bathroom with a toilet, bathtub, and vanity with sink at Netherley Park in Union City, GA.",
        "public_id": "019d7466-f25f-70bd-a69d-8220027976c5",
        "storage_key": "property/6767906449167332/019d7466-f25f-70bd-a69d-8220027976c5.webp",
        "width": 1280,
        "height": 849
      },
      "title": "Apartment",
      "description": "Relax and unwind in your private bathroom featuring a spacious tub and shower combination.",
      "link": "",
      "alt_text": "Interior bathroom with a toilet, bathtub, and vanity with sink at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e1a07056-d2f3-4a0d-bb51-acdad4704042",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-f199-7511-96ad-8e1c6275bcdb.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, and bathtub/shower at Netherley Park in Union City, GA.",
        "public_id": "019d7466-f199-7511-96ad-8e1c6275bcdb",
        "storage_key": "property/6767906449167332/019d7466-f199-7511-96ad-8e1c6275bcdb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Step into this well-appointed bathroom featuring a spacious vanity with granite countertops, a large mirror, and a bathtub/shower combination.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, mirror, and bathtub/shower at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_14edb941-4f55-4d12-af27-aac4f683cf42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-ea77-7768-aaf1-6f72dc85eeea.webp",
      "image_media": {
        "alt_text": "Bedroom with three doors and a window at Netherley Park in Union City, GA.",
        "public_id": "019d7466-ea77-7768-aaf1-6f72dc85eeea",
        "storage_key": "property/6767906449167332/019d7466-ea77-7768-aaf1-6f72dc85eeea.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Apartment",
      "description": "A neutral-colored bedroom with plush carpeting, three interior doors, and a large window with blinds.",
      "link": "",
      "alt_text": "Bedroom with three doors and a window at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d93cc40f-57e2-4a88-8c9a-3c46f6d07884",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-ec78-74fc-aceb-8c1ff51c4a17.webp",
      "image_media": {
        "alt_text": "Entrance view of a living room with large windows and a ceiling fan at Netherley Park in Union City, GA.",
        "public_id": "019d7466-ec78-74fc-aceb-8c1ff51c4a17",
        "storage_key": "property/6767906449167332/019d7466-ec78-74fc-aceb-8c1ff51c4a17.webp",
        "width": 1280,
        "height": 836
      },
      "title": "Apartment",
      "description": "Welcome to your new home! This spacious living area features ample natural light from large windows and a ceiling fan for comfort.",
      "link": "",
      "alt_text": "Entrance view of a living room with large windows and a ceiling fan at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0fdbbbd-a35e-4064-adcf-44a8cd4706e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-e899-716a-ae1f-c53f34986925.webp",
      "image_media": {
        "alt_text": "Apartment buildings on a lake at Netherley Park in Union City, GA.",
        "public_id": "019d7466-e899-716a-ae1f-c53f34986925",
        "storage_key": "property/6767906449167332/019d7466-e899-716a-ae1f-c53f34986925.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Serene apartment community located on a picturesque lake, offering a peaceful and natural living environment.",
      "link": "",
      "alt_text": "Apartment buildings on a lake at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8db89f0d-8d88-49cd-831a-019396c3d173",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-e781-75ac-abdc-9edf17613fb9.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio and weight machines at Kilborough Apartments in Columbus Ohio.",
        "public_id": "019d7466-e781-75ac-abdc-9edf17613fb9",
        "storage_key": "property/6767906449167332/019d7466-e781-75ac-abdc-9edf17613fb9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, weight machines, and more.",
      "link": "",
      "alt_text": "Fitness center with cardio and weight machines at Kilborough Apartments in Columbus Ohio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8499a710-d76b-4220-b18c-fd23c5c57f3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-df8c-76bf-85cd-e71a9edfab0c.webp",
      "image_media": {
        "alt_text": "The Park at Netherley Welcome Center entrance with balloons and signage.",
        "public_id": "019d7466-df8c-76bf-85cd-e71a9edfab0c",
        "storage_key": "property/6767906449167332/019d7466-df8c-76bf-85cd-e71a9edfab0c.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Welcome to The Park at Netherley's leasing office and welcome center. See our available apartments and amenities today.",
      "link": "",
      "alt_text": "The Park at Netherley Welcome Center entrance with balloons and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90050627-af2e-468a-8f58-9fdeb53f2b23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-df82-704e-80ae-86f1c40a8043.webp",
      "image_media": {
        "alt_text": "Netherley Park Designer Apartment Homes monument sign.",
        "public_id": "019d7466-df82-704e-80ae-86f1c40a8043",
        "storage_key": "property/6767906449167332/019d7466-df82-704e-80ae-86f1c40a8043.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to Netherley Park, offering designer apartment homes. This monument sign is located at the entrance to the property.",
      "link": "",
      "alt_text": "Netherley Park Designer Apartment Homes monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1e2e2f0-1b12-44de-8cc8-1e146476bda5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-df80-77ef-bff1-dc3d4252303f.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing wall next to a lake and swimming pool at Netherley Park in Union City, GA.",
        "public_id": "019d7466-df80-77ef-bff1-dc3d4252303f",
        "storage_key": "property/6767906449167332/019d7466-df80-77ef-bff1-dc3d4252303f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the playground, perfect for children, located beside a serene lake and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Playground with slides and climbing wall next to a lake and swimming pool at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f14cfa96-479c-4d3e-bdaf-89ac1f98b689",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-df7e-7778-b65f-41c6a9d6b0df.webp",
      "image_media": {
        "alt_text": "Welcome center building exterior with signage and landscaping  at Netherley Park in Union City, GA.",
        "public_id": "019d7466-df7e-7778-b65f-41c6a9d6b0df",
        "storage_key": "property/6767906449167332/019d7466-df7e-7778-b65f-41c6a9d6b0df.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Exterior view of the welcoming center building, featuring clear signage and well-maintained landscaping, creating an inviting first impression.",
      "link": "",
      "alt_text": "Welcome center building exterior with signage and landscaping  at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d83f304-884b-4809-b439-116a1f0a8862",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-d1d9-75f5-8d03-6c8c34bb257d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and exterior staircases at Netherley Park in Union City, GA.",
        "public_id": "019d7466-d1d9-75f5-8d03-6c8c34bb257d",
        "storage_key": "property/6767906449167332/019d7466-d1d9-75f5-8d03-6c8c34bb257d.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring balconies and convenient exterior staircases, set against a backdrop of mature trees.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and exterior staircases at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07c20b2b-11f3-42f6-8cd4-3b2b673d2013",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-d740-712e-a3df-fffc4582187e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building 22 with manicured lawns and a paved walkway at Netherley Park in Union City, GA.",
        "public_id": "019d7466-d740-712e-a3df-fffc4582187e",
        "storage_key": "property/6767906449167332/019d7466-d740-712e-a3df-fffc4582187e.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Charming exterior view of apartment building 22, featuring well-maintained lawns and a clear path leading to the entrance.",
      "link": "",
      "alt_text": "Exterior view of apartment building 22 with manicured lawns and a paved walkway at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e19d9b7d-19b8-4098-97b5-b39ab898b34a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-d003-7378-b34a-e65aad0ce21c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings at Netherley Park in Union City, GA.",
        "public_id": "019d7466-d003-7378-b34a-e65aad0ce21c",
        "storage_key": "property/6767906449167332/019d7466-d003-7378-b34a-e65aad0ce21c.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and vibrant umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_59452193-bda7-469d-975c-a0c57f5769f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-cfe8-746f-930a-a99c97fe31b1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Netherley Park in Union City, GA.",
        "public_id": "019d7466-cfe8-746f-930a-a99c97fe31b1",
        "storage_key": "property/6767906449167332/019d7466-cfe8-746f-930a-a99c97fe31b1.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded by umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fdbbf0ef-3410-4c6c-983f-d8c2eb2e0c89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d7466-d222-7677-a9a4-782fbd6749a1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawn at Netherley Park in Union City, GA.",
        "public_id": "019d7466-d222-7677-a9a4-782fbd6749a1",
        "storage_key": "property/6767906449167332/019d7466-d222-7677-a9a4-782fbd6749a1.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Modern apartment buildings featuring private balconies, spacious green areas, and a welcoming exterior.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawn at Netherley Park in Union City, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_7518cc62-3788-42d3-bd2a-a09b18cf6782",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3410 Camp Creek Pkwy, Atlanta, GA 30344, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and salads. They also highlight the quick service, friendly staff, and clean environment.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-e617-75ab-8041-bfd8448ee83d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Chick-fil-A restaurant with red awnings and outdoor seating.",
        "public_id": "019d54ea-e617-75ab-8041-bfd8448ee83d",
        "storage_key": "property/6767906449167332/019d54ea-e617-75ab-8041-bfd8448ee83d.webp",
        "width": 2592,
        "height": 1456
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/camp-creek-parkway?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5455870232796308375&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.6564559",
      "poi_longitude": "-84.501688",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-494-9320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54ec-2fcb-722a-aa62-705a6228d9b4",
        "storage_key": "property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ07QnN2vi9IgRl6Nz_hElt0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_ab48d384-9d52-4384-a647-4316e0e26043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3390 Camp Creek Pkwy, East Point, GA 30344, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious soup, salad, and breadsticks. They also highlight the friendly and attentive service, and the clean and updated atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-f749-7588-9d4f-ade45e0fb060.webp",
      "poi_featured_image_media": {
        "alt_text": "Olive Garden Italian Kitchen logo on building exterior.",
        "public_id": "019d54ea-f749-7588-9d4f-ade45e0fb060",
        "storage_key": "property/6767906449167332/019d54ea-f749-7588-9d4f-ade45e0fb060.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/east-point/east-point-camp-creek/6463?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:east-point-ga-6463_pl:locurl_rd:1889",
      "poi_directions_map_url": "https://maps.google.com/?cid=12141316582590448719&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "33.656887",
      "poi_longitude": "-84.500676",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-439-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54ec-2fcb-722a-aa62-705a6228d9b4",
        "storage_key": "property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bFkNUnj9IgRTwTduhqffqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1fee10b8-ddc1-4caa-b84d-f25f97753a7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Hungry AF Old National",
      "poi_type": "Restaurants",
      "poi_address": "5495 Old National Hwy Suite B1, College Park, GA 30349, USA",
      "poi_short_description": "Casual restaurant known for wings, pasta, cheesesteaks, and other familiar bites.",
      "poi_long_description": "People say this restaurant serves delicious chicken wings, pasta, and Philly cheesesteaks. They highlight the generous portions, flavorful seasoning, and fresh, hot food. They also like the lively atmosphere and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-ecbc-753c-8ad4-9a4b0d372dec.webp",
      "poi_featured_image_media": {
        "alt_text": "Hungry AF restaurant exterior with bright signage and menu items displayed on the storefront.",
        "public_id": "019d54ea-ecbc-753c-8ad4-9a4b0d372dec",
        "storage_key": "property/6767906449167332/019d54ea-ecbc-753c-8ad4-9a4b0d372dec.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://thehungryaf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8127772147236130129&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hungry-af-old-national",
      "poi_latitude": "33.6062761",
      "poi_longitude": "-84.4735776",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-941-9609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54ec-2fcb-722a-aa62-705a6228d9b4",
        "storage_key": "property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9sXgjXj9IgRUc1Sg7Sly3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3523dad6-5952-4131-9016-936bf3a23502",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Whisk Breakfast & Brunch",
      "poi_type": "Restaurants",
      "poi_address": "3523 Camp Creek Pkwy, East Point, GA 30344, USA",
      "poi_short_description": "Cozy eatery offering breakfast and lunch eats, plus cocktails, wine and a relaxed vibe.",
      "poi_long_description": "People say this breakfast restaurant serves delicious oxtail hash, French toast bites, and smoked wings. They highlight the beautiful decor, inviting atmosphere, and reasonable prices. They also like the attentive and friendly staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-ecb2-701a-9c75-0f35020d655e.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a commercial building with a prominent sign reading 'Whisk' illuminated at dusk.",
        "public_id": "019d54ea-ecb2-701a-9c75-0f35020d655e",
        "storage_key": "property/6767906449167332/019d54ea-ecb2-701a-9c75-0f35020d655e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://whiskatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3816779391648263585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whisk-breakfast--brunch",
      "poi_latitude": "33.6558132",
      "poi_longitude": "-84.49970210000001",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-963-1377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
      "poi_map_icon_media": {
        "alt_text": "Utensils icon",
        "public_id": "019d54ec-2fcb-722a-aa62-705a6228d9b4",
        "storage_key": "property/6767906449167332/019d54ec-2fcb-722a-aa62-705a6228d9b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUbX_2Pj9IgRoe05caLs9zQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_1a4946bc-253a-458b-98a8-d631d7b8071e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Old National Discount Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2660 Godby Rd, College Park, GA 30349, USA",
      "poi_short_description": "Shopping mall featuring a variety of vendors, including those for shoes, custom T-shirts, and art.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and products, including clothing, shoes, jewelry, and accessories. They also highlight the good deals, the friendly people, and the fun, unique shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-e5a9-75a8-8eeb-f8e776d363f1.webp",
      "poi_featured_image_media": {
        "alt_text": "Discount Mall building exterior",
        "public_id": "019d54ea-e5a9-75a8-8eeb-f8e776d363f1",
        "storage_key": "property/6767906449167332/019d54ea-e5a9-75a8-8eeb-f8e776d363f1.webp",
        "width": 506,
        "height": 458
      },
      "poi_business_url": "https://www.instagram.com/creativecustoms_of_atl?igshid=ZGNjOWZkYTE3MQ==&utm_source=qr",
      "poi_directions_map_url": "https://maps.google.com/?cid=1186082002979020589&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-national-discount-mall",
      "poi_latitude": "33.6152629",
      "poi_longitude": "-84.47541629999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-881-5992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fc3-719d-9af3-623fd0cd8b8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54ec-2fc3-719d-9af3-623fd0cd8b8a",
        "storage_key": "property/6767906449167332/019d54ec-2fc3-719d-9af3-623fd0cd8b8a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv1eY0Qjj9IgRLV8MLkzPdRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ffd35ca2-ec80-4707-9f23-2020a4d6ada6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "H Mart Riverdale",
      "poi_type": "Shopping & Retail",
      "poi_address": "6335 GA-85 T, Riverdale, GA 30274, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "People say this grocery store offers a wide selection of Asian, Caribbean, and other international foods, including fresh seafood, meats, and produce. They also highlight the good prices, the fast-moving lines, and the extensive selection of Korean products.\n\nOther reviews mention the produce can be spoiled.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-ed6a-716e-bc79-fdf05de6f27e.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Super H Mart with colorful pennant flags and a grand opening banner.",
        "public_id": "019d54ea-ed6a-716e-bc79-fdf05de6f27e",
        "storage_key": "property/6767906449167332/019d54ea-ed6a-716e-bc79-fdf05de6f27e.webp",
        "width": 3072,
        "height": 2040
      },
      "poi_business_url": "http://www.hmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8856476576301505585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-riverdale",
      "poi_latitude": "33.5828934",
      "poi_longitude": "-84.41264340000001",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 678-435-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f6e-7709-adb2-096690d5f291.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54ec-2f6e-7709-adb2-096690d5f291",
        "storage_key": "property/6767906449167332/019d54ec-2f6e-7709-adb2-096690d5f291.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfOT55389IgRMdwExIWG6Ho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_ce7b6ea8-e40f-48db-ac15-830aaa321c88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Publix Super Market at Princeton Lakes",
      "poi_type": "Shopping & Retail",
      "poi_address": "3730 Carmia Dr SW #200, Atlanta, GA 30331, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, quality meats, and delicious baked goods. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the deli can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-e5bb-7014-b7ae-93f45f55c09d.webp",
      "poi_featured_image_media": {
        "alt_text": "Publix grocery store exterior with a golf cart and people.",
        "public_id": "019d54ea-e5bb-7014-b7ae-93f45f55c09d",
        "storage_key": "property/6767906449167332/019d54ea-e5bb-7014-b7ae-93f45f55c09d.webp",
        "width": 2529,
        "height": 1420
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1056&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=15512759848586561818&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-princeton-lakes",
      "poi_latitude": "33.6564029",
      "poi_longitude": "-84.510747",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-346-9253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f6e-7709-adb2-096690d5f291.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54ec-2f6e-7709-adb2-096690d5f291",
        "storage_key": "property/6767906449167332/019d54ec-2f6e-7709-adb2-096690d5f291.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm08qexfi9IgRGsnxZORkSNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_277bcbda-0efb-4e17-969b-4595b85be345",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "680 Lamar Hutcheson Pkwy, Riverdale, GA 30274, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of supplies and materials. They also highlight the friendly and knowledgeable staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-e610-75cb-98a7-21b21b0e3235.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot logo and store front",
        "public_id": "019d54ea-e610-75cb-98a7-21b21b0e3235",
        "storage_key": "property/6767906449167332/019d54ea-e610-75cb-98a7-21b21b0e3235.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Riverdale/GA/Riverdale/30274/178?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17363746086232234148&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.5587798",
      "poi_longitude": "-84.41108129999999",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-907-6027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fc3-719d-9af3-623fd0cd8b8a.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54ec-2fc3-719d-9af3-623fd0cd8b8a",
        "storage_key": "property/6767906449167332/019d54ec-2fc3-719d-9af3-623fd0cd8b8a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-0Z7rGz79IgRpJjzfxFr-PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7106d91a-7063-405e-ac8b-44fbda66d8c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "5820 Riverdale Rd, College Park, GA 30349, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-e5f3-7769-9dda-d353e73034d6.webp",
      "poi_featured_image_media": {
        "alt_text": "ALDI grocery store logo",
        "public_id": "019d54ea-e5f3-7769-9dda-d353e73034d6",
        "storage_key": "property/6767906449167332/019d54ea-e5f3-7769-9dda-d353e73034d6.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/college-park/5820-riverdale-road/l931",
      "poi_directions_map_url": "https://maps.google.com/?cid=10724280870745126530&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.596478",
      "poi_longitude": "-84.428016",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f6e-7709-adb2-096690d5f291.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54ec-2f6e-7709-adb2-096690d5f291",
        "storage_key": "property/6767906449167332/019d54ec-2f6e-7709-adb2-096690d5f291.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxyDTmrD89IgRgrZH3KFM1JQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_db9153b5-c501-4eaf-88d6-03eb6700ce7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Georgia Military College",
      "poi_type": "Education",
      "poi_address": "320 NW Broad St Suite 200, Fairburn, GA 30213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.gmc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7491303249541038231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgia-military-college",
      "poi_latitude": "33.5717298",
      "poi_longitude": "-84.573093",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-379-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fac-70e4-b9c4-87676a5ea472.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54ec-2fac-70e4-b9c4-87676a5ea472",
        "storage_key": "property/6767906449167332/019d54ec-2fac-70e4-b9c4-87676a5ea472.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIyC3ZCPn9IgRl4CfZZ109mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e1de9f5c-3619-4bb6-98cb-1f46be596bfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Jeannette Cathy Children's Center",
      "poi_type": "Education",
      "poi_address": "5180 Buffington Rd, Atlanta, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-0a69-738e-9872-f9383b3d83f4.webp",
      "poi_featured_image_media": {
        "alt_text": "Children's reading area with colorful books, small tables, and chairs.",
        "public_id": "019d54eb-0a69-738e-9872-f9383b3d83f4",
        "storage_key": "property/6767906449167332/019d54eb-0a69-738e-9872-f9383b3d83f4.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://families.decal.ga.gov/ChildCare/detail/2351",
      "poi_directions_map_url": "https://maps.google.com/?cid=1258229087354487137&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jeannette-cathy-childrens-center",
      "poi_latitude": "33.6140908",
      "poi_longitude": "-84.4986357",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-761-2323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fac-70e4-b9c4-87676a5ea472.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54ec-2fac-70e4-b9c4-87676a5ea472",
        "storage_key": "property/6767906449167332/019d54ec-2fac-70e4-b9c4-87676a5ea472.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJleCwILnj9IgRYQHURbAgdhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c991cad5-d150-4400-b4fc-ebc6a87eef25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Andy's Plaza",
      "poi_type": "Entertainment",
      "poi_address": "6504 Church St, Riverdale, GA 30274, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-0c51-7381-90c8-4bbbdf62fa0b.webp",
      "poi_featured_image_media": {
        "alt_text": "Andy's Plaza monument sign with multiple business listings, including Protecs Designs&Print, Taxes, Auto Insurance, and Dominican Hair Salon.",
        "public_id": "019d54eb-0c51-7381-90c8-4bbbdf62fa0b",
        "storage_key": "property/6767906449167332/019d54eb-0c51-7381-90c8-4bbbdf62fa0b.webp",
        "width": 2592,
        "height": 1944
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6671521433912677548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "andys-plaza",
      "poi_latitude": "33.5774688",
      "poi_longitude": "-84.41378019999999",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09cTHmH79IgRrBTFm2UBllw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_6096eb37-03f7-44d5-a640-65f34445fff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Chateau Plaza",
      "poi_type": "Entertainment",
      "poi_address": "6587 Church St, Riverdale, GA 30274, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-fc64-76dc-8647-821159e5e8f8.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a commercial building with a large empty parking lot.",
        "public_id": "019d54ea-fc64-76dc-8647-821159e5e8f8",
        "storage_key": "property/6767906449167332/019d54ea-fc64-76dc-8647-821159e5e8f8.webp",
        "width": 2592,
        "height": 1944
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12753873531220880567&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chateau-plaza",
      "poi_latitude": "33.575351",
      "poi_longitude": "-84.41535119999999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcUbuMWf79IgRt2ytWmfc_rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_fb1a1113-11a0-4da5-aa66-da224269e05b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4700 Jonesboro Rd, Union City, GA 30291, USA",
      "poi_short_description": "Gym featuring a fitness studio for abs and stretching, plus a range of equipment.",
      "poi_long_description": "Visitors say this gym has a clean facility with state-of-the-art, well-maintained equipment, and they appreciate the friendly and helpful staff. They also highlight the welcoming and inclusive atmosphere, making it a comfortable place to work out.\n\nSome reviews mention the parking can be limited, especially for truck drivers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ea-fcb8-770b-8d66-bd594a167911.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out on various machines in a large, brightly lit gym with purple and yellow equipment.",
        "public_id": "019d54ea-fcb8-770b-8d66-bd594a167911",
        "storage_key": "property/6767906449167332/019d54ea-fcb8-770b-8d66-bd594a167911.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/union-city-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17931632449486939650&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.5673889",
      "poi_longitude": "-84.54304839999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-306-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWzlIjrn9IgRAmaJ-rT02fg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5fde744b-48fb-4b17-8291-495e106825bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6385 Old National Hwy, Atlanta, GA 30349, USA",
      "poi_short_description": "Chain health club featuring cardio and weight machines, classes, and a pool.",
      "poi_long_description": "People say this gym offers a variety of equipment, including free weights, stacked weight machines, and cardio machines, as well as amenities like a pool, Jacuzzi, steam room, and basketball court. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.\n\nOther reviews mention the equipment can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-1239-7108-a122-6b4495e0d70d.webp",
      "poi_featured_image_media": {
        "alt_text": "Three people smiling while using rowing machines in a bright gym.",
        "public_id": "019d54eb-1239-7108-a122-6b4495e0d70d",
        "storage_key": "property/6767906449167332/019d54eb-1239-7108-a122-6b4495e0d70d.webp",
        "width": 3072,
        "height": 2047
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=602&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11311968654445697808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.5799751",
      "poi_longitude": "-84.47219079999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-304-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQcUDA_j9IgRENuWzo4v_Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9ff048c0-12dd-480c-84ff-337085310cad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Old National Nails Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "5015 Old National Hwy d, Atlanta, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-21c8-7188-b13c-612b2a0a2105.webp",
      "poi_featured_image_media": {
        "alt_text": "Welcome to Old National Nail & Spa sign",
        "public_id": "019d54eb-21c8-7188-b13c-612b2a0a2105",
        "storage_key": "property/6767906449167332/019d54eb-21c8-7188-b13c-612b2a0a2105.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "http://oldnationalnailsspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18141932127207648265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-national-nails-spa",
      "poi_latitude": "33.6185726",
      "poi_longitude": "-84.4734046",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-500-3630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq7IiGSPj9IgRCWx1TSYXxfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_9d5e5e0c-43b3-49a4-980c-c5f4e105625e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Union City Veterinary Medical Center & Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "6702 Shannon Pkwy, Union City, GA 30291, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-2b9f-724c-94bb-7893f8ed88e3.webp",
      "poi_featured_image_media": {
        "alt_text": "Union City Veterinary Medical Center logo with a puppy and kitten.",
        "public_id": "019d54eb-2b9f-724c-94bb-7893f8ed88e3",
        "storage_key": "property/6767906449167332/019d54eb-2b9f-724c-94bb-7893f8ed88e3.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://ucvmc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12281976700277074067&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-city-veterinary-medical-center--emergency-clinic",
      "poi_latitude": "33.5727549",
      "poi_longitude": "-84.5387366",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-964-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEY3_drnm9IgRk6ijd7xYcqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a3de6ada-f275-4fea-9dda-c12e2b4df601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "LifeLine Animal Project Spay & Neuter Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2533 Sullivan Rd, Atlanta, GA 30337, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-2d85-754c-a066-9f274395841e.webp",
      "poi_featured_image_media": {
        "alt_text": "A tortoiseshell cat wears a cone of shame while resting on a plush chair.",
        "public_id": "019d54eb-2d85-754c-a066-9f274395841e",
        "storage_key": "property/6767906449167332/019d54eb-2d85-754c-a066-9f274395841e.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://lifelineanimal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16048979865979814183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lifeline-animal-project-spay--neuter-clinic",
      "poi_latitude": "33.625047",
      "poi_longitude": "-84.472144",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-973-2881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6AYBgPj9IgRJ4EfLyhuud4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_654a8eb3-4c95-4450-b834-bac02a2a38ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Aicha Hair Braiding Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "5123 Old National Hwy, College Park, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-2c14-776d-baaa-c2532b9a735c.webp",
      "poi_featured_image_media": {
        "alt_text": "Hair salon interior with chairs and mirrors.",
        "public_id": "019d54eb-2c14-776d-baaa-c2532b9a735c",
        "storage_key": "property/6767906449167332/019d54eb-2c14-776d-baaa-c2532b9a735c.webp",
        "width": 1500,
        "height": 530
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7836898495485102737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aicha-hair-braiding-salon",
      "poi_latitude": "33.6151164",
      "poi_longitude": "-84.4738117",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-761-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT6vvuA_j9IgRkcou9KhBwmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5f51efe0-1cf9-4033-b21f-18e899601e02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Chan&Bay Nail Salon Union Ga ( Lash & Brows Tint)",
      "poi_type": "Health and Wellness",
      "poi_address": "4550 Jonesboro Rd P, Union City, GA 30291, USA",
      "poi_short_description": "Nail salon offering services such as waxing, as well as eyelashes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-4068-776f-a7ff-58b4aca01643.webp",
      "poi_featured_image_media": {
        "alt_text": "People getting their nails done at a busy nail salon.",
        "public_id": "019d54eb-4068-776f-a7ff-58b4aca01643",
        "storage_key": "property/6767906449167332/019d54eb-4068-776f-a7ff-58b4aca01643.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://chanandbaynailspaunioncity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17894198722051841475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chanbay-nail-salon-union-ga--lash--brows-tint",
      "poi_latitude": "33.566336",
      "poi_longitude": "-84.5359969",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-604-6958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx79nxb3m9IgRwx0mIO72VPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_d5de573c-1ba5-43f0-8c28-c125a89318e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Tri-County Pediatrics",
      "poi_type": "Health and Wellness",
      "poi_address": "808 Commerce Blvd suite a, Riverdale, GA 30296, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-411e-713c-963b-526d734605d6.webp",
      "poi_featured_image_media": {
        "alt_text": "Wall mural depicting a countryside scene with horses and dogs, set in an arched frame.",
        "public_id": "019d54eb-411e-713c-963b-526d734605d6",
        "storage_key": "property/6767906449167332/019d54eb-411e-713c-963b-526d734605d6.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.tricountypediatrics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15423667044779630045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tri-county-pediatrics",
      "poi_latitude": "33.5475802",
      "poi_longitude": "-84.4179732",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-996-9191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f74-75ad-9194-050309a54af4.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54ec-2f74-75ad-9194-050309a54af4",
        "storage_key": "property/6767906449167332/019d54ec-2f74-75ad-9194-050309a54af4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVXlsSL79IgR3R39iXXfC9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_93a54eee-30c4-474f-a10e-70d32e19b738",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Kids Avenue Pediatrics",
      "poi_type": "Health and Wellness",
      "poi_address": "1720 Phoenix Blvd # 900, College Park, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=594264847276302376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kids-avenue-pediatrics",
      "poi_latitude": "33.613818",
      "poi_longitude": "-84.445551",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-909-8007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f74-75ad-9194-050309a54af4.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d54ec-2f74-75ad-9194-050309a54af4",
        "storage_key": "property/6767906449167332/019d54ec-2f74-75ad-9194-050309a54af4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWI5rjHj9IgRKOBn5LpAPwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_64d04941-e646-4564-9eb8-a410cb41d8d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Kenwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "GA-279, Fayetteville, GA 30214, USA",
      "poi_short_description": "Green space with trails, a playground, courts for basketball, tennis, and volleyball, and more.",
      "poi_long_description": "People say this park offers a track, walking trails, and various sports facilities, including basketball, tennis, and volleyball courts. They highlight the spacious picnic areas, shaded trails, and ample parking, making it suitable for family gatherings and events. They also like the clean environment and well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-5065-779b-8318-01ce443e67a7.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, tunnels, and a tractor bouncer.",
        "public_id": "019d54eb-5065-779b-8318-01ce443e67a7",
        "storage_key": "property/6767906449167332/019d54eb-5065-779b-8318-01ce443e67a7.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://fayettecountyga.gov/departments/parks_recreation/kenwood_park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=13268430538379053641&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kenwood-park",
      "poi_latitude": "33.5157822",
      "poi_longitude": "-84.438396",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-716-4320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54ec-2f71-7259-b230-ea9d561fc563",
        "storage_key": "property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyFwUzXl9IgRSUoHh0bvIrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9e9c5319-d7ce-4655-9826-aa01528163b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Duncan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6000 Rivertown Rd, Fairburn, GA 30213, USA",
      "poi_short_description": "Well-kept park offering grassy fields, a pond for running or walking around, and playground equipment for kids.",
      "poi_long_description": "Visitors say this city park offers a refreshing pool with a large slide, a playground with swings and climbing equipment for kids of all ages, and clean pavilions and bathrooms. They also highlight the park's spacious and well-maintained grounds, peaceful atmosphere, and abundance of parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-469b-7258-ab11-2dc4b73ccc4b.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing wall under yellow umbrellas",
        "public_id": "019d54eb-469b-7258-ab11-2dc4b73ccc4b",
        "storage_key": "property/6767906449167332/019d54eb-469b-7258-ab11-2dc4b73ccc4b.webp",
        "width": 2048,
        "height": 1155
      },
      "poi_business_url": "http://www.fairburn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16216048035485943225&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "duncan-park",
      "poi_latitude": "33.5725708",
      "poi_longitude": "-84.5992431",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-964-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54ec-2f71-7259-b230-ea9d561fc563",
        "storage_key": "property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dpbblzn9IgRuYXPn8X5CuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_0f5e048d-16bc-4f3a-9531-5db418bbc0fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Georgia Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3895 Ben Hill Rd, Atlanta, GA 30349, USA",
      "poi_short_description": "Sports-oriented destination with multiple fields for soccer, rugby and ultimate frisbee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-6234-701a-ae81-ff2744125cab.webp",
      "poi_featured_image_media": {
        "alt_text": "Soccer field with players practicing.",
        "public_id": "019d54eb-6234-701a-ae81-ff2744125cab",
        "storage_key": "property/6767906449167332/019d54eb-6234-701a-ae81-ff2744125cab.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://georgiasportspark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13386995773236084965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georgia-sports-park",
      "poi_latitude": "33.6461951",
      "poi_longitude": "-84.5159967",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54ec-2f71-7259-b230-ea9d561fc563",
        "storage_key": "property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8qYFyTi9IgR5YBkebopyLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_46392642-c95d-4d51-8381-bed35c462614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Charles E. Phillips Esquire Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4400 Herschel Rd, College Park, GA 30337, USA",
      "poi_short_description": "Sizable green space featuring a baseball field, a track, a playground and tennis courts.",
      "poi_long_description": "People say this park offers a playground, splash pad, basketball and tennis courts, a walking path, and a soccer field. They highlight the park is clean, spacious, and has a variety of activities for children and adults. They also like the ample parking and the opportunity to watch planes go by.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-88a8-72e6-9473-e4aff032671b.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d54eb-88a8-72e6-9473-e4aff032671b",
        "storage_key": "property/6767906449167332/019d54eb-88a8-72e6-9473-e4aff032671b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.collegeparkrca.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17855542880171412277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charles-e-phillips-esquire-park",
      "poi_latitude": "33.6350798",
      "poi_longitude": "-84.47179679999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-669-3776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54ec-2f71-7259-b230-ea9d561fc563",
        "storage_key": "property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvywBCvvi9IgRNUtflKWhy_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_96a020c4-b19f-490d-a147-8325c8395cd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Welcome All Park & Multipurpose Facility",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4255 Will Lee Rd, Atlanta, GA 30349, USA",
      "poi_short_description": "Public indoor/outdoor recreation facility with playing fields, swimming pools & a fitness center.",
      "poi_long_description": "Public indoor/outdoor recreation facility with playing fields, swimming pools & a fitness center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-61d3-7756-aa9e-c55d6c00b781.webp",
      "poi_featured_image_media": {
        "alt_text": "Pavilion with picnic tables and trees in the background.",
        "public_id": "019d54eb-61d3-7756-aa9e-c55d6c00b781",
        "storage_key": "property/6767906449167332/019d54eb-61d3-7756-aa9e-c55d6c00b781.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.cityofsouthfultonga.gov/2489/Welcome-All-Park-Multipurpose-Facility",
      "poi_directions_map_url": "https://maps.google.com/?cid=2758331590872429289&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "welcome-all-park--multipurpose-facility",
      "poi_latitude": "33.6320249",
      "poi_longitude": "-84.5263064",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 470-809-7170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54ec-2f71-7259-b230-ea9d561fc563",
        "storage_key": "property/6767906449167332/019d54ec-2f71-7259-b230-ea9d561fc563.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYBfLILh9IgR6XKwtvePRyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6111d55b-2183-4efb-97ce-e5fadd766e73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Chick-fil-A Support Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5200 Buffington Rd, Atlanta, GA 30349, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches, strips & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches, strips & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-5003-72c9-81ee-97f54eec580b.webp",
      "poi_featured_image_media": {
        "alt_text": "Various cars on display, including the Batmobile, a green muscle car, and several vintage automobiles.",
        "public_id": "019d54eb-5003-72c9-81ee-97f54eec580b",
        "storage_key": "property/6767906449167332/019d54eb-5003-72c9-81ee-97f54eec580b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/officialrules",
      "poi_directions_map_url": "https://maps.google.com/?cid=5699126295235252851&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a-support-center",
      "poi_latitude": "33.6138568",
      "poi_longitude": "-84.4906285",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-765-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSukNL_j9IgRc9KVlStdF08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_269a9e15-2dd7-4a90-b68c-1dbe9ddac23f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "TenCate Protective Fabrics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6501 Mall Blvd, Union City, GA 30291, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-6184-752d-bf78-642b57ac4a80.webp",
      "poi_featured_image_media": {
        "alt_text": "Tensate monument sign in front of a brick building with trees and grass.",
        "public_id": "019d54eb-6184-752d-bf78-642b57ac4a80",
        "storage_key": "property/6767906449167332/019d54eb-6184-752d-bf78-642b57ac4a80.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://us.tencatefabrics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1306394796370987793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tencate-protective-fabrics",
      "poi_latitude": "33.575608",
      "poi_longitude": "-84.531246",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-969-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34t0i6_m9IgREYscTiU_IRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8107a26b-ce7d-4230-a6d1-85965683c0d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Union City City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5047 Union St, Union City, GA 30291, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ee-0668-73e9-b9b6-0754cb807b90.webp",
      "poi_featured_image_media": {
        "alt_text": "Union City Hall building entrance with brick facade and landscaping.",
        "public_id": "019d54ee-0668-73e9-b9b6-0754cb807b90",
        "storage_key": "property/6767906449167332/019d54ee-0668-73e9-b9b6-0754cb807b90.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3049066258895637417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-city-city-hall",
      "poi_latitude": "33.5791495",
      "poi_longitude": "-84.5521212",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-964-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fba-7675-b9e5-14d2259382ff.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d54ec-2fba-7675-b9e5-14d2259382ff",
        "storage_key": "property/6767906449167332/019d54ec-2fba-7675-b9e5-14d2259382ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH7n_S87m9IgRqYsampt1UCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_edab5d30-e73e-414e-87ef-fc48ef78468c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "CFA - Oakmont B",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3455 Naturally Fresh Blvd B, Atlanta, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-9da6-7044-b227-f96a1c7fe532.webp",
      "poi_featured_image_media": {
        "alt_text": "Rows of empty lecture hall seats with a few people in the distance and a book on a desk.",
        "public_id": "019d54eb-9da6-7044-b227-f96a1c7fe532",
        "storage_key": "property/6767906449167332/019d54eb-9da6-7044-b227-f96a1c7fe532.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://chick-fil-a.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456986318714510500&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cfa---oakmont-b",
      "poi_latitude": "33.6134529",
      "poi_longitude": "-84.5021514",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzdERsfj9IgRpBxdsL2u-S8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_649f7a2a-679d-4153-99c4-7d13f1c4f741",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "poi_name": "Lovehoney US",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5156 Southridge Pkwy #110, College Park, GA 30349, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54eb-82bf-75d9-94b5-c239707afaeb.webp",
      "poi_featured_image_media": {
        "alt_text": "Lovehoney logo",
        "public_id": "019d54eb-82bf-75d9-94b5-c239707afaeb",
        "storage_key": "property/6767906449167332/019d54eb-82bf-75d9-94b5-c239707afaeb.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "https://www.lovehoney.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13156558968092712949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lovehoney-us",
      "poi_latitude": "33.615036",
      "poi_longitude": "-84.4241027",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d54ec-2fb7-718d-b40f-b3c7c4e353e7",
        "storage_key": "property/6767906449167332/019d54ec-2fb7-718d-b40f-b3c7c4e353e7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnd_o0BAF9YgR9V-lz6x8lbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_8c3c68aa-8f50-46c2-a7ee-8bdd4998fdd5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_a15b813e-0420-4949-8fbd-173350ff5204",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_208653a8-affd-4785-8410-165fc6737fc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_b0e0d1a1-6fd7-4f1e-926c-8cd94a3c971a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_f7ab2dc8-242d-4fe7-9293-adb536647b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_ed1b0af6-b707-4814-9c29-d515660144ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5f286932-1c38-45f1-b081-3ebfd11c24bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "rating": "5.0",
      "name": "SSE TV",
      "text": "The ladies in the office especially Mrs. Leslie have been very helpful in an eventful situation. They went above and beyond to make sure things were right with not just the move in but the continued stay. It looks to be a solid team that aims to make this a great place to live.",
      "date": "2025-11-26",
      "title": ""
    },
    {
      "id": "custom_e3e2adc1-dad9-4bed-bcf3-6d9fe617625d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "rating": "5",
      "name": "Sheila Thomas",
      "text": "The maintenance man Tony is a great asset to this property he came to make repairs to my unit and he was very respectful also he saw me struggling to take my garbage he removed it for me and that’s a big help to me since I’m disabled . 👏👏👏👏👏 very professional keep up the great work.",
      "date": "2026-04-15",
      "title": "false"
    },
    {
      "id": "custom_ff852d3a-2bdc-4682-9ffd-43149d521e81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "rating": "5",
      "name": "Renee",
      "text": "This staff is simply a cut above, they go above and beyond for the residents and always have time to explain things and get work orders ✅ in a timely manner. If you are looking for a home and community look no further 🏠 welcome home\n",
      "date": "2026-08-14",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f31ec621081169e02b02d342",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ed-fcf6-74c4-9656-459e6488977b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54ed-fcf6-74c4-9656-459e6488977b",
        "storage_key": "property/6767906449167332/019d54ed-fcf6-74c4-9656-459e6488977b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,285 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pZzBGFoBxRX"
    },
    {
      "id": "ec_7324db5bcfe31053ce1ee2db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167332/019d54ed-fe19-779f-a5e7-e08aa9fe5da0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54ed-fe19-779f-a5e7-e08aa9fe5da0",
        "storage_key": "property/6767906449167332/019d54ed-fe19-779f-a5e7-e08aa9fe5da0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DfdFRRHn98L"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-c8de-738d-89b9-ebcb7b39f159",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Netherley Park Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332"
    },
    {
      "lead_collector_id": "019db23f-c94f-71b9-876d-49a13e345609",
      "lead_source": "FACEBOOK_ADS",
      "name": "Netherley Park Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332"
    },
    {
      "lead_collector_id": "019db23f-c9c0-74ca-afd8-1841c5523425",
      "lead_source": "LANDING_PAGE",
      "name": "Netherley Park Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-union-city-ga-netherley-park",
      "search_query": "pet friendly apartments Union City GA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Union City, GA",
      "h2_subtitle": "Looking for pet-friendly living in Union City, GA? Discover Netherley Park where pets are welcome and comfort is guaranteed.",
      "page_copy": "Nestled in the heart of Fulton County, Netherley Park offers pet friendly apartments in Union City, GA that provide comfort and convenience for you and your furry friends. Our community welcomes pets with open arms, ensuring both you and your pet feel right at home. Designed with spacious layouts, our apartments feature large closets, perfect for storing all your pet essentials, and carpeted bedrooms for cozy living.\n\nNetherley Park doesn't just cater to humans; our lush grounds provide ample space for pets to play. Beyond the pet-friendly amenities, you'll enjoy an equipped kitchen ideal for whipping up a meal after a long day or a simple snack for your pet. Plus, with our sparkling swimming pool and nearby playground, entertainment is never far from home. Make Netherley Park your pet-friendly sanctuary in Union City, GA today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Union City, GA",
      "seo_description": "Discover pet-friendly living in Union City, GA at Netherley Park. Spacious layouts and a warm community welcome you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-with-pool-fulton-county-netherley-park",
      "search_query": "apartments with pool Fulton County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Fulton County",
      "h2_subtitle": "Discover the joy of living with a pool in Fulton County at Netherley Park. Enjoy relaxing amenities and a welcoming community.",
      "page_copy": "Netherley Park is your ideal destination if you're searching for apartments with a pool in Fulton County. Our refreshing swimming pool is the centerpiece of our community, providing a perfect spot to unwind and relax with family and friends. Situated in Union City, GA, our residents enjoy not only the luxury of a pool but a friendly atmosphere that enhances the living experience.\n\nIn addition to enjoying poolside relaxation, residents can take advantage of spacious floor plans with large closets, offering ample storage space. Each apartment features a fully equipped kitchen and cozy carpeted bedrooms, ensuring comfort at every turn. Complement your lifestyle with playful strolls at our community playground and enjoy all that living in Fulton County at Netherley Park has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Fulton County",
      "seo_description": "Enjoy Netherley Park's pool and other great amenities. Live in the heart of Fulton County with comfort and relaxation just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-near-fitness-center-30291-netherley-park",
      "search_query": "apartments near fitness center 30291",
      "category": "Amenity",
      "h1_title": "Apartments Near Fitness Center in 30291",
      "h2_subtitle": "Explore residences near fitness centers in the 30291 area at Netherley Park. Enhance your lifestyle in Union City, GA.",
      "page_copy": "Conveniently located in Union City's 30291 area, Netherley Park offers charming apartments near fitness centers, perfect for those who value staying active. Our community is perfectly positioned to provide quick access to local fitness facilities, ensuring that your health and wellness goals are always within reach.\n\nAt Netherley Park, enjoy spacious living spaces with large closets, fully equipped kitchens that fit every lifestyle, and cozy carpeted bedrooms designed for relaxation. The welcoming environment also includes a sparkling swimming pool and a playful playground, making it easy to balance work, play, and fitness. Experience the advantages of living near fitness centers while embracing the comfort of Netherley Park in the heart of Union City, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fitness Center in 30291",
      "seo_description": "Discover comfortable living at Netherley Park, with easy access to local fitness centers in Union City's 30291 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "spacious-floor-plans-union-city-netherley-park",
      "search_query": "spacious floor plans Union City",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plans in Union City",
      "h2_subtitle": "Experience expansive living in Union City with Netherley Park's spacious floor plans, designed for comfort and style.",
      "page_copy": "Discover the beauty of expansive living at Netherley Park, where spacious floor plans in Union City redefine comfort. Our thoughtfully designed apartments offer generous layouts, providing ample room for all your lifestyle needs. Each space boasts large closets for extra storage and carpeted bedrooms, creating a cozy and inviting atmosphere.\n\nLocated in the vibrant community of Union City, GA, Netherley Park not only offers roomy interiors but also a range of amenities including an equipped kitchen perfect for culinary adventures. Step outside and enjoy our sparkling swimming pool and playground, making leisure and recreation an everyday convenience. Choose Netherley Park, where spacious living meets exceptional community features in Union City.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plans in Union City",
      "seo_description": "Enjoy Netherley Park's expansive floor plans in Union City, GA. Experience comfortable living with ample space and delightful amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-with-large-closets-ga-netherley-park",
      "search_query": "apartments with large closets in GA",
      "category": "Amenity",
      "h1_title": "Apartments with Large Closets in GA",
      "h2_subtitle": "Find the perfect apartments with large closets in GA at Netherley Park. Enjoy convenience and style in every home.",
      "page_copy": "Nestled in Union City, GA, Netherley Park offers exceptional apartments with large closets that are perfect for organizing your belongings and maximizing space. Each residence is designed with practicality and style in mind, featuring ample storage solutions that cater to your living needs.\n\nBeyond spacious closets, Netherley Park provides a comprehensive living experience. Enjoy a fully equipped kitchen, where creating meals is a joy, as well as carpeted bedrooms that offer comfort and warmth. The community boasts a refreshing swimming pool and a fun-filled playground, providing opportunities for relaxation and recreation steps from your door. Experience the difference of living in an apartment that prioritizes both functionality and comfort at Netherley Park in Union City, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Large Closets in GA",
      "seo_description": "Explore Netherley Park's spacious apartments with large closets in GA, where convenience meets comfort in Union City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-union-city-ga-netherley-park",
      "search_query": "one bedroom apartments union city ga",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Union City, GA",
      "h2_subtitle": "Discover ideal one bedroom apartments in Union City, GA at Netherley Park. Experience comfort and convenience.",
      "page_copy": "At Netherley Park, we offer charming one bedroom apartments in the heart of Union City, GA. Designed with your lifestyle in mind, these well-appointed residences provide the perfect blend of comfort and functionality. Enjoy large closets that offer ample storage, a fully equipped kitchen ready for your culinary explorations, and cozy carpeted bedrooms that invite relaxation.\n\nLiving in Union City means having access to a community rich in amenities. Residents of Netherley Park benefit from a sparkling swimming pool and a playful playground, creating a balanced lifestyle full of leisure and convenience. Embrace the welcoming atmosphere and modern comforts of our one bedroom apartments at Netherley Park, situated conveniently in Union City, GA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Union City, GA",
      "seo_description": "Find welcoming one bedroom apartments at Netherley Park in Union City, GA. Experience comfort with great amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-fulton-county-netherley-park",
      "search_query": "two bedroom apartments fulton county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Fulton County",
      "h2_subtitle": "Explore spacious two bedroom apartments in Fulton County at Netherley Park. Perfectly crafted for families or roommates.",
      "page_copy": "Discover the perfect combination of space and comfort with Netherley Park's two bedroom apartments in Fulton County. These thoughtfully designed homes provide ample living space ideal for families, roommates, or anyone desiring extra room. Each apartment features large closets, a fully equipped kitchen, and carpeted bedrooms, ensuring a comfortable and inviting environment.\n\nSituated in Union City, a vibrant part of Fulton County, Netherley Park offers more than just exceptional interiors. Enjoy community amenities like a refreshing swimming pool and a playground that presents opportunities for relaxation and fun. Experience the balance of suburban tranquility with the convenience of urban living in our spacious two bedroom apartments, tailored to enhance your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Fulton County",
      "seo_description": "Discover spacious two bedroom apartments at Netherley Park in Fulton County. Perfect for families with excellent amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-30291-netherley-park",
      "search_query": "three bedroom apartments near 30291",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 30291",
      "h2_subtitle": "Find spacious three bedroom apartments near 30291 at Netherley Park. Ideal for families seeking comfort and convenience.",
      "page_copy": "Netherley Park invites you to discover spacious three bedroom apartments near the 30291 area, tailored to meet the demands of modern living. Located in Union City, these well-designed apartments offer plenty of room for everyone with large closets providing excellent storage and carpeted bedrooms adding a touch of comfort and warmth.\n\nResidents will appreciate the convenience of a fully equipped kitchen perfect for culinary adventures, along with community amenities like a sparkling swimming pool and a well-maintained playground. These features make Netherley Park an ideal choice for families or anyone needing generous space to live comfortably, coupled with a location that ensures easy access to the best of what Union City has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 30291",
      "seo_description": "Explore spacious three bedroom apartments at Netherley Park near 30291. Perfect for families looking for comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-near-georgia-military-college-fulton-county-netherley-park",
      "search_query": "apartments near georgia military college fulton county",
      "category": "School",
      "h1_title": "Apartments Near Georgia Military College",
      "h2_subtitle": "Explore convenient apartments near Georgia Military College in Fulton County. Ideal location for students and faculty.",
      "page_copy": "Looking for the perfect place to call home near Georgia Military College in Fulton County? Discover the inviting apartments at Netherley Park. Located just a short drive away, our community offers a prime location for students and faculty seeking a comfortable and convenient living environment. \n\nOur apartments feature spacious layouts, large closets, and equipped kitchens, ensuring you have all the necessities for an ideal living experience. Enjoy relaxing by our swimming pool or utilize the playground — amenities designed to enhance your daily routine. Discover the balance of comfort and accessibility at Netherley Park, perfectly situated for those attending Georgia Military College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Georgia Military College",
      "seo_description": "Find convenient apartments at Netherley Park near Georgia Military College in Fulton County. Ideal for students seeking comfort and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-near-tri-county-pediatrics-union-city-netherley-park",
      "search_query": "apartments near Tri-County Pediatrics Union City",
      "category": "Hospital",
      "h1_title": "Apartments Near Tri-County Pediatrics",
      "h2_subtitle": "Discover family-friendly apartments near Tri-County Pediatrics in Union City. Perfect living for proximity and convenience.",
      "page_copy": "Searching for a home close to Tri-County Pediatrics in Union City? Netherley Park offers ideal apartments that ensure easy access to this vital facility. Our community is perfectly situated for families wanting convenience, with spacious layouts and amenities designed to enhance family living.\n\nEach of our apartments boasts large closets, carpeted bedrooms, and fully equipped kitchens that create a cozy and functional living space. The community features, such as a swimming pool and a playground, provide on-site entertainment and leisure options for families with children. Choose Netherley Park for its advantageous location and the welcoming environment it offers near Tri-County Pediatrics.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tri-County Pediatrics",
      "seo_description": "Live near Tri-County Pediatrics at Netherley Park in Union City. Ideal apartments for families seeking convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-close-to-kids-avenue-pediatrics-fulton-county-netherley-park",
      "search_query": "apartments close to Kids Avenue Pediatrics Fulton County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Kids Avenue Pediatrics",
      "h2_subtitle": "Find convenient living close to Kids Avenue Pediatrics in Fulton County at Netherley Park. Ideal for families prioritizing nearby healthcare services.",
      "page_copy": "Netherley Park offers apartments close to Kids Avenue Pediatrics in Fulton County, making it a convenient choice for families. Located in Union City, our community ensures you’re within a short distance from essential pediatric care, providing peace of mind and easy access to healthcare when you need it.\n\nOur apartments feature large closets, carpeted bedrooms, and fully equipped kitchens, providing a comfortable and practical living environment. Beyond the home, enjoy community amenities like a refreshing swimming pool and a playground ideal for children. At Netherley Park, you'll find a welcoming atmosphere with all the comforts of home and the advantage of being near Kids Avenue Pediatrics.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Kids Avenue Pediatrics",
      "seo_description": "Discover apartments at Netherley Park near Kids Avenue Pediatrics in Fulton County, offering great features and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-near-kenwood-park-union-city-netherley-park",
      "search_query": "apartments near Kenwood Park Union City",
      "category": "Park",
      "h1_title": "Apartments Near Kenwood Park",
      "h2_subtitle": "Explore living options near Kenwood Park in Union City. Netherley Park offers convenience and comfort for outdoor enthusiasts.",
      "page_copy": "Enjoy the perfect blend of nature and city living with apartments near Kenwood Park at Netherley Park. Located conveniently in Union City, our community offers prime access to Kenwood Park, a scenic spot for recreation and relaxation.\n\nEach apartment at Netherley Park comes with features like large closets, carpeted bedrooms, and equipped kitchens, ensuring a comfortable and practical living environment. Plus, take advantage of our community amenities, including a swimming pool and playground, which provide fun and leisure for all ages. Choose Netherley Park for its proximity to Kenwood Park and enjoy a lifestyle that includes the best of both outdoor adventure and home comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kenwood Park",
      "seo_description": "Netherley Park offers ideal apartments near Kenwood Park in Union City for those who love nature and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "living-near-georgia-sports-park-30291-netherley-park",
      "search_query": "living near Georgia Sports Park 30291",
      "category": "Park",
      "h1_title": "Living Near Georgia Sports Park",
      "h2_subtitle": "Experience the vibrant lifestyle of living near Georgia Sports Park in the 30291 area. Ideal for sports enthusiasts and families alike.",
      "page_copy": "Experience the thrill of living near Georgia Sports Park at Netherley Park, situated in Union City's 30291 area. Our community offers an excellent opportunity for sports enthusiasts and families who enjoy easy access to outdoor activities and events offered at this popular park.\n\nNetherley Park provides comfortable living with spacious apartments featuring large closets, carpeted bedrooms, and fully equipped kitchens. The community amenities, such as a sparkling swimming pool and a playground, complete the living experience, offering leisure and relaxation right at home. Embrace the energetic lifestyle at Georgia Sports Park while enjoying the welcoming comfort of Netherley Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Georgia Sports Park 30291",
      "seo_description": "Discover vibrant living at Netherley Park, close to Georgia Sports Park in Union City, with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "close-to-charles-e-phillips-esquire-park-fulton-county-netherley-park",
      "search_query": "close to Charles E. Phillips Esquire Park Fulton County",
      "category": "Park",
      "h1_title": "Close to Charles E. Phillips Esquire Park",
      "h2_subtitle": "Discover the benefits of living close to Charles E. Phillips Esquire Park. Enjoy the leisure and outdoor activities right in Fulton County with Netherley Park.",
      "page_copy": "Netherley Park offers a fantastic living experience close to Charles E. Phillips Esquire Park in Fulton County. This proximity allows residents to take advantage of the beautiful outdoor spaces and recreational facilities the park offers, perfect for family outings or solo relaxation.\n\nOur apartments at Netherley Park come with comforts like large closets, carpeted bedrooms, and fully equipped kitchens, ensuring a cozy home environment. Additionally, residents can enjoy community features such as a swimming pool and a playground, making it ideal for families and those who love an active lifestyle. Choose Netherley Park to live near the serenity and activities of Charles E. Phillips Esquire Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close to Charles E. Phillips Esquire Park",
      "seo_description": "Netherley Park offers ideal apartments near Charles E. Phillips Esquire Park in Fulton County, perfect for enjoying nature and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167332",
      "source": "custom",
      "page_item_url": "apartments-nearby-welcome-all-park-union-city-ga-netherley-park",
      "search_query": "apartments nearby Welcome All Park Union City GA",
      "category": "Park",
      "h1_title": "Apartments Nearby Welcome All Park",
      "h2_subtitle": "Discover apartments close to Welcome All Park in Union City, GA. Enjoy easy access to recreation and vibrant community living at Netherley Park.",
      "page_copy": "For those seeking apartments nearby Welcome All Park in Union City, GA, Netherley Park provides an ideal location. Perfect for those who love park-side living, our community offers effortless access to the lush expanses and recreational facilities of Welcome All Park.\n\nNetherley Park apartments are designed for comfortable living, featuring large closets, carpeted bedrooms, and equipped kitchens. The community amenities include a refreshing swimming pool and a fun playground, ensuring there's something for everyone. Located in a vibrant yet serene part of Union City, GA, Netherley Park combines the best of convenience and comfort with the added advantage of being near Welcome All Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Nearby Welcome All Park",
      "seo_description": "Explore Netherley Park Apartments near Welcome All Park, Union City, GA, offering great amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6075"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671056365"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PK833463"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "9f860ce11ef3b59d"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "591072978"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "dd8a75043fe8aed2e9e3"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a13518fa-d0cb-11f0-a5aa-a38d11552ac8"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://apollostore.blob.core.windows.net/netherleypark/uploads/assets/untitled-video-5.e80954fe.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a13518fa-d0cb-11f0-a5aa-a38d11552ac8/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InlRUXV1ZmJXT2wrZGxvSFJ4eGtVT2c9PSIsInZhbHVlIjoidkxHSUxHbFZDVnFXbCthSmRLT3dhZz09IiwibWFjIjoiY2QyZjE2NTI3ZmZmZTYwMDc0N2ZmNmRjNjFmNzZiYjM0OThkZjk5YmFlMDY5ZjgwNmUxYWVmNzMxNzI5OWQyNiJ9"
    }
  ],
  "custom_qb_id": "6075",
  "custom_repli_id": "11671056365",
  "custom_google_gtm_id": "GTM-PK833463",
  "custom_knock_community_id": "9f860ce11ef3b59d",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "591072978",
  "custom_call_rail_account_hash": "dd8a75043fe8aed2e9e3",
  "custom_eliseai_building_token": "a13518fa-d0cb-11f0-a5aa-a38d11552ac8",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://apollostore.blob.core.windows.net/netherleypark/uploads/assets/untitled-video-5.e80954fe.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a13518fa-d0cb-11f0-a5aa-a38d11552ac8/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InlRUXV1ZmJXT2wrZGxvSFJ4eGtVT2c9PSIsInZhbHVlIjoidkxHSUxHbFZDVnFXbCthSmRLT3dhZz09IiwibWFjIjoiY2QyZjE2NTI3ZmZmZTYwMDc0N2ZmNmRjNjFmNzZiYjM0OThkZjk5YmFlMDY5ZjgwNmUxYWVmNzMxNzI5OWQyNiJ9",
  "custom_audioeye_site_id": "233572d7-eec2-4938-b19c-1d61281b97b4",
  "custom_audioeye_site_hash": "d900bf1178e31d56822e15ad391a27ed"
};

export const generatedAt = '2026-10-01T17:23:36.693Z';
